module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_pp23_8019.d6c8cec9.png";